import { useContext, useMemo } from 'react';

import { MarketingPlanningSocketContext } from '../MarketingPlanningSocketContext';

export const useSocketHighlightColor = ({ path }) => {
  const { highlighted } = useContext(MarketingPlanningSocketContext);

  const highlightedElement = useMemo(() => {
    return highlighted[path];
  }, [highlighted, path]);

  return useMemo(() => {
    if (highlightedElement) {
      return highlightedElement?.user?.color;
    }
  }, [highlightedElement]);
};
